module.exports = __webpack_public_path__ + "static/media/cm.a56034b7.svg";